module.exports = __webpack_public_path__ + "img/img1.690f94ce.jpg";